/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TreePlotter v3 API
 * TreePlotter v3 API
 * OpenAPI spec version: 4.51.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ClearFieldConfig,
  CreateField,
  Field,
  ForbiddenErrorResponse,
  GetFieldParams,
  GetFieldsParams,
  Id,
  ImportTP2FieldConfig,
  PutCategory,
  PutCategory201,
  PutField,
  PutField201,
  UnauthorizedErrorResponse,
  UpdateField,
} from ".././model";

import { httpClient } from "../../../src/common/infrastructure/api/http-client";

export const importFieldConfig = (
  importTP2FieldConfig: ImportTP2FieldConfig,
  signal?: AbortSignal
) => {
  return httpClient<void | void>({
    url: `/command-service/tenant/service/tp2-interop/import-tp2-field-config`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: importTP2FieldConfig,
    signal,
  });
};

export const getImportFieldConfigMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importFieldConfig>>,
    TError,
    { data: ImportTP2FieldConfig },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importFieldConfig>>,
  TError,
  { data: ImportTP2FieldConfig },
  TContext
> => {
  const mutationKey = ["importFieldConfig"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importFieldConfig>>,
    { data: ImportTP2FieldConfig }
  > = (props) => {
    const { data } = props ?? {};

    return importFieldConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportFieldConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof importFieldConfig>>
>;
export type ImportFieldConfigMutationBody = ImportTP2FieldConfig;
export type ImportFieldConfigMutationError = void | UnauthorizedErrorResponse;

export const useImportFieldConfig = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importFieldConfig>>,
      TError,
      { data: ImportTP2FieldConfig },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof importFieldConfig>>,
  TError,
  { data: ImportTP2FieldConfig },
  TContext
> => {
  const mutationOptions = getImportFieldConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const putFieldConfig = (
  importTP2FieldConfig: ImportTP2FieldConfig,
  signal?: AbortSignal
) => {
  return httpClient<void | void>({
    url: `/command-service/tenant/service/tp2-interop/put-tp2-field-config`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: importTP2FieldConfig,
    signal,
  });
};

export const getPutFieldConfigMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putFieldConfig>>,
    TError,
    { data: ImportTP2FieldConfig },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putFieldConfig>>,
  TError,
  { data: ImportTP2FieldConfig },
  TContext
> => {
  const mutationKey = ["putFieldConfig"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putFieldConfig>>,
    { data: ImportTP2FieldConfig }
  > = (props) => {
    const { data } = props ?? {};

    return putFieldConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutFieldConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof putFieldConfig>>
>;
export type PutFieldConfigMutationBody = ImportTP2FieldConfig;
export type PutFieldConfigMutationError = void | UnauthorizedErrorResponse;

export const usePutFieldConfig = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putFieldConfig>>,
      TError,
      { data: ImportTP2FieldConfig },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putFieldConfig>>,
  TError,
  { data: ImportTP2FieldConfig },
  TContext
> => {
  const mutationOptions = getPutFieldConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const clearFieldConfig = (
  tenantId: Id,
  clearFieldConfig: ClearFieldConfig,
  signal?: AbortSignal
) => {
  return httpClient<void | void>({
    url: `/command-service/tenant/aggregate/tenant/${tenantId}/clear-field-config`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: clearFieldConfig,
    signal,
  });
};

export const getClearFieldConfigMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearFieldConfig>>,
    TError,
    { tenantId: Id; data: ClearFieldConfig },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearFieldConfig>>,
  TError,
  { tenantId: Id; data: ClearFieldConfig },
  TContext
> => {
  const mutationKey = ["clearFieldConfig"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearFieldConfig>>,
    { tenantId: Id; data: ClearFieldConfig }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return clearFieldConfig(tenantId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearFieldConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearFieldConfig>>
>;
export type ClearFieldConfigMutationBody = ClearFieldConfig;
export type ClearFieldConfigMutationError = void | UnauthorizedErrorResponse;

export const useClearFieldConfig = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof clearFieldConfig>>,
      TError,
      { tenantId: Id; data: ClearFieldConfig },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof clearFieldConfig>>,
  TError,
  { tenantId: Id; data: ClearFieldConfig },
  TContext
> => {
  const mutationOptions = getClearFieldConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getFields = (
  tenantId: Id,
  params: GetFieldsParams,
  signal?: AbortSignal
) => {
  return httpClient<Field[]>({
    url: `/query-service/tenant/${tenantId}/field-information/get-fields`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFieldsQueryKey = (
  tenantId?: Id,
  params?: GetFieldsParams
) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "field-information",
    "get-fields",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFields>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetFieldsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFields>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFieldsQueryKey(tenantId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFields>>> = ({
    signal,
  }) => getFields(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getFields>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFields>>
>;
export type GetFieldsQueryError = ForbiddenErrorResponse | void;

export function useGetFields<
  TData = Awaited<ReturnType<typeof getFields>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetFieldsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFields>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFields>>,
          TError,
          Awaited<ReturnType<typeof getFields>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFields<
  TData = Awaited<ReturnType<typeof getFields>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetFieldsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFields>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFields>>,
          TError,
          Awaited<ReturnType<typeof getFields>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFields<
  TData = Awaited<ReturnType<typeof getFields>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetFieldsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFields>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetFields<
  TData = Awaited<ReturnType<typeof getFields>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetFieldsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFields>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFieldsQueryOptions(tenantId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getField = (
  tenantId: Id,
  params: GetFieldParams,
  signal?: AbortSignal
) => {
  return httpClient<Field>({
    url: `/query-service/tenant/${tenantId}/field-information/get-field`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFieldQueryKey = (tenantId?: Id, params?: GetFieldParams) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "field-information",
    "get-field",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFieldQueryOptions = <
  TData = Awaited<ReturnType<typeof getField>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetFieldParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getField>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFieldQueryKey(tenantId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getField>>> = ({
    signal,
  }) => getField(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getField>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetFieldQueryResult = NonNullable<
  Awaited<ReturnType<typeof getField>>
>;
export type GetFieldQueryError = ForbiddenErrorResponse | void;

export function useGetField<
  TData = Awaited<ReturnType<typeof getField>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetFieldParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getField>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getField>>,
          TError,
          Awaited<ReturnType<typeof getField>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetField<
  TData = Awaited<ReturnType<typeof getField>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetFieldParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getField>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getField>>,
          TError,
          Awaited<ReturnType<typeof getField>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetField<
  TData = Awaited<ReturnType<typeof getField>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetFieldParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getField>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetField<
  TData = Awaited<ReturnType<typeof getField>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetFieldParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getField>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFieldQueryOptions(tenantId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createField = (
  fieldId: Id,
  createField: CreateField,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/field/aggregate/field/${fieldId}/create-field`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createField,
    signal,
  });
};

export const getCreateFieldMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createField>>,
    TError,
    { fieldId: Id; data: CreateField },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createField>>,
  TError,
  { fieldId: Id; data: CreateField },
  TContext
> => {
  const mutationKey = ["createField"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createField>>,
    { fieldId: Id; data: CreateField }
  > = (props) => {
    const { fieldId, data } = props ?? {};

    return createField(fieldId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof createField>>
>;
export type CreateFieldMutationBody = CreateField;
export type CreateFieldMutationError = void | UnauthorizedErrorResponse;

export const useCreateField = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createField>>,
      TError,
      { fieldId: Id; data: CreateField },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createField>>,
  TError,
  { fieldId: Id; data: CreateField },
  TContext
> => {
  const mutationOptions = getCreateFieldMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateField = (
  fieldId: Id,
  updateField: UpdateField,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/field/aggregate/field/${fieldId}/update`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateField,
    signal,
  });
};

export const getUpdateFieldMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateField>>,
    TError,
    { fieldId: Id; data: UpdateField },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateField>>,
  TError,
  { fieldId: Id; data: UpdateField },
  TContext
> => {
  const mutationKey = ["updateField"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateField>>,
    { fieldId: Id; data: UpdateField }
  > = (props) => {
    const { fieldId, data } = props ?? {};

    return updateField(fieldId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateField>>
>;
export type UpdateFieldMutationBody = UpdateField;
export type UpdateFieldMutationError = void | UnauthorizedErrorResponse;

export const useUpdateField = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateField>>,
      TError,
      { fieldId: Id; data: UpdateField },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateField>>,
  TError,
  { fieldId: Id; data: UpdateField },
  TContext
> => {
  const mutationOptions = getUpdateFieldMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete field
 */
export const deleteField = (fieldId: Id, signal?: AbortSignal) => {
  return httpClient<void>({
    url: `/command-service/field/aggregate/field/${fieldId}/delete-field`,
    method: "POST",
    signal,
  });
};

export const getDeleteFieldMutationOptions = <
  TError = void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteField>>,
    TError,
    { fieldId: Id },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteField>>,
  TError,
  { fieldId: Id },
  TContext
> => {
  const mutationKey = ["deleteField"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteField>>,
    { fieldId: Id }
  > = (props) => {
    const { fieldId } = props ?? {};

    return deleteField(fieldId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteField>>
>;

export type DeleteFieldMutationError = void;

/**
 * @summary Delete field
 */
export const useDeleteField = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteField>>,
      TError,
      { fieldId: Id },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteField>>,
  TError,
  { fieldId: Id },
  TContext
> => {
  const mutationOptions = getDeleteFieldMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Archive a field by setting its lifeCycleStatus to Deprecated. Idempotent at the domain level — re-archiving an already-deprecated field returns a validation error.
 * @summary Archive field
 */
export const archiveField = (fieldId: Id, signal?: AbortSignal) => {
  return httpClient<void>({
    url: `/command-service/field/aggregate/field/${fieldId}/archive-field`,
    method: "POST",
    signal,
  });
};

export const getArchiveFieldMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveField>>,
    TError,
    { fieldId: Id },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveField>>,
  TError,
  { fieldId: Id },
  TContext
> => {
  const mutationKey = ["archiveField"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveField>>,
    { fieldId: Id }
  > = (props) => {
    const { fieldId } = props ?? {};

    return archiveField(fieldId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveFieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveField>>
>;

export type ArchiveFieldMutationError = void | UnauthorizedErrorResponse;

/**
 * @summary Archive field
 */
export const useArchiveField = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof archiveField>>,
      TError,
      { fieldId: Id },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof archiveField>>,
  TError,
  { fieldId: Id },
  TContext
> => {
  const mutationOptions = getArchiveFieldMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Put field
 */
export const putField = (
  fieldId: Id,
  putField: PutField,
  signal?: AbortSignal
) => {
  return httpClient<PutField201 | void>({
    url: `/command-service/field/aggregate/field/${fieldId}/put-field`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: putField,
    signal,
  });
};

export const getPutFieldMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putField>>,
    TError,
    { fieldId: Id; data: PutField },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putField>>,
  TError,
  { fieldId: Id; data: PutField },
  TContext
> => {
  const mutationKey = ["putField"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putField>>,
    { fieldId: Id; data: PutField }
  > = (props) => {
    const { fieldId, data } = props ?? {};

    return putField(fieldId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutFieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof putField>>
>;
export type PutFieldMutationBody = PutField;
export type PutFieldMutationError = void | UnauthorizedErrorResponse;

/**
 * @summary Put field
 */
export const usePutField = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putField>>,
      TError,
      { fieldId: Id; data: PutField },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putField>>,
  TError,
  { fieldId: Id; data: PutField },
  TContext
> => {
  const mutationOptions = getPutFieldMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Put category
 */
export const putCategory = (
  categoryId: Id,
  putCategory: PutCategory,
  signal?: AbortSignal
) => {
  return httpClient<PutCategory201 | void>({
    url: `/command-service/field/aggregate/category/${categoryId}/put-category`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: putCategory,
    signal,
  });
};

export const getPutCategoryMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCategory>>,
    TError,
    { categoryId: Id; data: PutCategory },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCategory>>,
  TError,
  { categoryId: Id; data: PutCategory },
  TContext
> => {
  const mutationKey = ["putCategory"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCategory>>,
    { categoryId: Id; data: PutCategory }
  > = (props) => {
    const { categoryId, data } = props ?? {};

    return putCategory(categoryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCategory>>
>;
export type PutCategoryMutationBody = PutCategory;
export type PutCategoryMutationError = void | UnauthorizedErrorResponse;

/**
 * @summary Put category
 */
export const usePutCategory = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putCategory>>,
      TError,
      { categoryId: Id; data: PutCategory },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putCategory>>,
  TError,
  { categoryId: Id; data: PutCategory },
  TContext
> => {
  const mutationOptions = getPutCategoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete category
 */
export const deleteCategory = (categoryId: Id, signal?: AbortSignal) => {
  return httpClient<void>({
    url: `/command-service/field/aggregate/category/${categoryId}/delete-category`,
    method: "POST",
    signal,
  });
};

export const getDeleteCategoryMutationOptions = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCategory>>,
    TError,
    { categoryId: Id },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  { categoryId: Id },
  TContext
> => {
  const mutationKey = ["deleteCategory"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCategory>>,
    { categoryId: Id }
  > = (props) => {
    const { categoryId } = props ?? {};

    return deleteCategory(categoryId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCategory>>
>;

export type DeleteCategoryMutationError = void | UnauthorizedErrorResponse;

/**
 * @summary Delete category
 */
export const useDeleteCategory = <
  TError = void | UnauthorizedErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCategory>>,
      TError,
      { categoryId: Id },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCategory>>,
  TError,
  { categoryId: Id },
  TContext
> => {
  const mutationOptions = getDeleteCategoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
